export default "__VITE_ASSET__CfZFgUPf__"